import DeviceDetector from 'device-detector-js';

export const detectUserDevice = () => {
  const userAgentData = navigator.userAgent;
  return new DeviceDetector().parse(userAgentData);
};
